/**
 * Fixed width of the selection checkbox column in pixels.
 * Matches a comfortable touch target size (48px).
 */
export const SELECTION_COLUMN_WIDTH = 48;

/**
 * Test ID prefix for selection-related elements.
 */
export const SELECTION_TEST_ID_PREFIX = 'eag-grid-select';